import { IconContext } from 'react-icons'
import { MdOutlineLogout } from 'react-icons/md'
import { useNavigate } from 'react-router-dom'

export const Logout: React.FC = () => {
  const navigate = useNavigate()

  const logout = (): void => {
    localStorage.removeItem('auth')
    navigate('/login')
  }
  return (
    <div
      className="flex cursor-pointer items-center space-x-2"
      onClick={logout}
    >
      <IconContext.Provider value={{ color: 'black' }}>
        <MdOutlineLogout />
      </IconContext.Provider>
      <span>{'ログアウト'}</span>
    </div>
  )
}
